module.exports = __webpack_public_path__ + "assets/img/ui-icons_ffffff_256x240.png";